module.exports = __webpack_public_path__ + "media/images/yellow_light_hover-b16ec4ce876c4ab6702c3b5f4170ce1f.jpg";